var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgSaveMood = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#save-mood_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.539 100.235c2.451-1.415 6.439-1.415 8.89 0 2.451 1.416 2.451 3.718 0 5.134-2.451 1.415-6.439 1.414-8.892 0-2.449-1.416-2.449-3.72.002-5.134Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.539 105.225c2.452 1.414 6.439 1.415 8.892 0 1.174-.678 1.786-1.561 1.834-2.451l.004.003.002-1.232-.262.225c-.287-.562-.812-1.092-1.58-1.535-2.451-1.414-6.439-1.415-8.89 0-.735.424-1.249.928-1.542 1.464l-.294-.117-.002 1.217.005-.002c.057.882.667 1.755 1.833 2.428Z",
    fill: "#501456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.433 103.953c1.192-.688 1.803-1.585 1.836-2.487-.036-.902-.648-1.796-1.837-2.482-2.451-1.414-6.439-1.415-8.89 0-1.192.688-1.803 1.585-1.837 2.488.036.9.649 1.794 1.837 2.48 2.452 1.417 6.44 1.417 8.891.001Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.084 101.395c-.548-.317-.677-.754-.287-.98.388-.224 1.148-.151 1.695.166.548.317.676.755.288.98-.389.224-1.148.149-1.696-.166ZM152.985 103.184c-.548-.316-.676-.755-.288-.979.389-.224 1.149-.151 1.697.166.547.316.676.754.288.979-.39.224-1.15.15-1.697-.166ZM149.767 101.367c-.209-.121-.21-.316 0-.436l3.822-2.208a.84.84 0 0 1 .758 0c.209.12.209.317 0 .436l-3.824 2.208a.827.827 0 0 1-.756 0Z",
    fill: "#501456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78 101.561a.498.498 0 0 0 .16-.142c.017-.214-.16-.465-.51-.667-.548-.316-1.307-.39-1.697-.166a.497.497 0 0 0-.16.141c-.017.215.161.466.511.668.548.315 1.307.39 1.696.166ZM154.681 103.35a.493.493 0 0 0 .159-.141c.017-.215-.161-.467-.51-.668-.548-.317-1.307-.39-1.696-.166a.5.5 0 0 0-.16.142c-.018.213.161.465.511.667.547.316 1.307.39 1.696.166ZM150.524 101.368l3.824-2.207a.427.427 0 0 0 .093-.072c-.01-.071-.061-.14-.155-.195a.835.835 0 0 0-.756 0l-3.823 2.207a.374.374 0 0 0-.093.072c.01.071.061.14.155.194a.834.834 0 0 0 .755.001Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.468 26.36s3.028 6.31 10.424 6.09l.597 1.633a2.594 2.594 0 0 1-1.161 3.145c-1.823 1.038-4.918 1.956-8.815-.16l-1.045-10.707Z",
    fill: "url(#save-mood_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.666 86.909s-.593.544-.792 1.236c-.197.694-.394 1.386.396 1.534.792.149 1.534.79 2.028 1.484.495.692 1.667.905 2.92.94 1.014.027 1.038-.694.94-1.04-.099-.346-1.188-1.236-1.98-1.88-.792-.643-1.83-2.275-1.83-2.275h-1.682ZM13.428 92.469l-.524 1.28c-.176.428-.22.897-.13 1.35.15.736.401 1.842.654 2.316.394.742 1.977.88 2.571.638.595-.242.339-1.711 0-3.26-.156-.714-.742-2.325-.742-2.325h-1.83v.001Z",
    fill: "#00AF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.44 92.773-.237-2.899h2.249l-.316 3.061s-.987.663-1.696-.162Z",
    fill: "url(#save-mood_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.659 87.452-.276-3.668 2.565.236-.591 3.432c-.001 0-.317.434-1.698 0Z",
    fill: "url(#save-mood_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.248 50.695s-.192 24.123-3.219 34.393c0 0-.852.63-2.883-.358 0 0-1.368-20.253-2-22.567-.63-2.314-.347-9.236-.347-9.236l8.449-2.232Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.468 54.036s-.608 21.857-.766 23.83c-.157 1.972 1.265 12.284 1.265 12.284s1.26.908 2.68.103c0 0 2.767-16.031 3.278-19.339.51-3.307 3.067-17.904 3.067-17.904l-9.524 1.026Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.973 26.833c.666-.498 2.795-1.703 3.87-1.883 1.294-.217 3.014.454 4.188.615 1.093.94 2.448 3.321 2.127 9.354-.4 7.492.738 15.627.766 20.442-1.192.227-5.298 1.687-6.517.254-.206-5.665.437-16.654-.28-21.913-.587-4.287-3.09-5.985-4.154-6.869Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.157 34.918c.322-6.032-1.034-8.413-2.127-9.353 2.036.276 3.168 3.642 3.52 5.355.56 2.7.487 26.952.487 26.952s-.289.05-.775.14c-.766.14-1.471-.487-1.474-1.322-.018-5.364.01-15.018.37-21.772Z",
    fill: "url(#save-mood_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.178 19.646-1.201 6.262c-.087.454.145.906.563 1.104.777.37 2.098.787 3.414.248.485-.199.79-.689.739-1.21L21.294 22l-3.116-2.354Z",
    fill: "url(#save-mood_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 33.599c-.585-4.312-3.09-5.877-4.153-6.766-.736.26-1.355.802-1.878 1.492-.76 1.002-1.311 2.327-1.694 3.632-1.322 3.291-2.66 8.05-.88 10.903.063 6.004.534 13.468 1.66 17.198 0 0 1.1.34 1.492-2.715 0 0 .157 3.587 3.143 2.727.71-.204 1.66-.433 2.696-.663.644-.143 1.096-.77 1.07-1.478-.237-6.343-.785-19.388-1.456-24.33Z",
    fill: "url(#save-mood_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.609 44.349c-.997-.267-5.014-3.264-6.558-4.434-.45-.341-1.082-.359-1.524-.008-.433.344-.863.93-.894 1.906-.02.67.402 1.277 1.036 1.495l6.433 2.221s1.398 2.49 3.617 2.805c2.218.315 2.563-1.544 2.125-2.255-.514-.837-2.995-1.398-4.235-1.73Z",
    fill: "url(#save-mood_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.281 39.269a.188.188 0 0 1-.17-.109c-1.005-2.167.447-5.53.509-5.67a.185.185 0 0 1 .246-.097.187.187 0 0 1 .096.246c-.014.033-1.447 3.35-.511 5.363a.186.186 0 0 1-.17.267Z",
    fill: "url(#save-mood_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.038 34.278a.969.969 0 0 1 .197-.965c1.027-1.159 3.983-4.584 4.395-6.12.501-1.862-.162-2.85-.376-3.8-.214-.95.697-.581.932.31.235.89 1.002-.394 1.164-.782.163-.387.841-2.435 1.667-2.644.825-.21 1.914 1.594.423 4.948 0 0-1.384 1.531-1.81 2.969-.51 1.716-2.129 5.422-3.106 7.388a1.333 1.333 0 0 1-1.8.595c-.632-.322-1.33-.893-1.686-1.9Z",
    fill: "url(#save-mood_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.376 17.769s.594 4.207-.174 6.026c-.767 1.818-2.496.925-4.578-.448-1.039-.686-1.873-2.652-1.873-2.652s2.621-7.59 6.625-2.926Z",
    fill: "url(#save-mood_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.963 16.275.766-.235a.426.426 0 0 0 .3-.442l-.06-.736a.968.968 0 0 1 1.387-.95l.124.06a.427.427 0 0 0 .613-.37.426.426 0 0 1 .642-.357l.193.114a.426.426 0 0 0 .634-.285l.074-.376c.087-.43.686-.466.824-.05l.046.14c.11.333.554.398.755.109l.105-.15a.427.427 0 0 1 .777.241v.088c.002.334.37.536.653.36l.318-.2a.427.427 0 0 1 .64.47l-.037.144c-.087.34.25.634.575.502l.508-.209a.427.427 0 0 1 .552.568l-.503 1.139c-.087.195.032.37.166.536.029.035.06.172.06.172.137.382.053.81-.219 1.11 0 0-.13.224-.208.232-.324.04-.725-.493-1.277.278-.583.816-2.195.555-4.114.914-.235.043-.382.19-.468.407-.253.023-.543.138-.628.516-.206.909.675 1.296.64 1.586-.219 1.847-.534.621-.723.241-.194-.388-.894-1.655-1.342-2.051-.2-.177-.5-.243-.77-.26a.425.425 0 0 1-.363-.593l.226-.527-1.018-.533c-.685-.36-.59-1.375.152-1.603Z",
    fill: "url(#save-mood_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.698 45.2c-.042-.033.388-2.42.552-3.32a.297.297 0 0 1 .388-.229l2.9.986c.137.046.221.185.2.328l-.55 3.51s-1.981-.065-3.49-1.275Z",
    fill: "#00AF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.44 124.354v1.92c.014 4.496 2.97 8.988 8.876 12.42 11.886 6.907 31.214 6.907 43.176 0 6.02-3.476 9.028-8.039 9.015-12.594v-1.919c.013 4.556-2.994 9.118-9.015 12.594-11.962 6.907-31.292 6.907-43.177 0-5.905-3.433-8.86-7.923-8.874-12.421Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.44 124.354v1.92c.014 4.496 2.97 8.988 8.876 12.419 2.34 1.36 4.967 2.453 7.773 3.277v-1.918c-2.804-.825-5.433-1.918-7.773-3.277-5.906-3.433-8.862-7.923-8.875-12.421Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.087 140.051v1.918c4.108 1.208 8.592 1.841 13.099 1.9v-1.92c-4.505-.058-8.99-.691-13.099-1.898Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.188 141.95v1.92c8.04.105 16.148-1.622 22.305-5.176.3-.175.594-.35.88-.529v-1.92c-.286.179-.58.356-.88.529-6.157 3.555-14.265 5.281-22.305 5.176Z",
    fill: "#DDDEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.374 136.245v1.92c3.194-2 5.449-4.323 6.762-6.777v-1.92c-1.315 2.454-3.57 4.777-6.762 6.777Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.134 129.468v1.92c.92-1.72 1.378-3.505 1.373-5.288v-1.919c.005 1.782-.452 3.566-1.373 5.287Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.453 111.763c-11.963 6.906-12.022 18.104-.137 25.011 11.886 6.907 31.214 6.907 43.176 0 11.963-6.907 12.029-18.104.144-25.011-11.886-6.907-31.22-6.907-43.183 0Z",
    fill: "#F1F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.273 120.484.03 3.718c.011 4.374 2.885 8.74 8.628 12.076 11.556 6.715 30.349 6.716 41.979 0 5.853-3.379 8.778-7.816 8.766-12.245l-.029-3.718c.012 4.429-2.912 8.866-8.765 12.245-11.631 6.716-30.425 6.716-41.98 0-5.742-3.338-8.617-7.704-8.63-12.076Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.273 120.484.03 3.718c.011 4.373 2.885 8.739 8.628 12.076 2.275 1.322 4.831 2.384 7.557 3.186l-.029-3.718c-2.726-.802-5.282-1.864-7.558-3.186-5.74-3.338-8.616-7.704-8.628-12.076Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.459 135.746.03 3.718c3.992 1.174 8.354 1.789 12.734 1.846l-.028-3.718c-4.382-.057-8.743-.672-12.736-1.846Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.194 137.591.028 3.718c7.818.102 15.702-1.575 21.688-5.033.292-.169.578-.339.856-.514l-.028-3.718c-.277.175-.562.345-.855.515-5.988 3.457-13.871 5.134-21.689 5.032Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.737 132.046.028 3.718c3.107-1.946 5.298-4.204 6.575-6.59l-.029-3.717c-1.276 2.385-3.469 4.643-6.574 6.589ZM100.312 125.456l.029 3.717c.896-1.672 1.34-3.407 1.335-5.142l-.029-3.718c.005 1.735-.441 3.471-1.335 5.143Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.036 108.241c-11.632 6.716-11.691 17.603-.134 24.318 11.556 6.716 30.348 6.716 41.98 0 11.632-6.716 11.696-17.602.14-24.318-11.557-6.715-30.354-6.715-41.986 0Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.244 119.734v1.92c.012 4.496 2.968 8.988 8.874 12.419 11.886 6.907 31.214 6.907 43.177 0 6.02-3.475 9.028-8.039 9.015-12.594v-1.919c.012 4.556-2.995 9.118-9.015 12.593-11.963 6.908-31.292 6.908-43.177 0-5.906-3.431-8.86-7.922-8.874-12.419Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.244 119.733v1.92c.012 4.497 2.968 8.988 8.874 12.42 2.34 1.359 4.97 2.452 7.772 3.276v-1.919c-2.803-.825-5.433-1.916-7.772-3.277-5.906-3.432-8.86-7.922-8.874-12.42ZM57.892 135.43v1.919c4.107 1.207 8.592 1.841 13.099 1.899v-1.919c-4.507-.058-8.992-.69-13.1-1.899Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.99 137.329v1.919c8.04.105 16.148-1.62 22.306-5.175.3-.174.594-.35.88-.529v-1.919a27.71 27.71 0 0 1-.88.528c-6.159 3.556-14.266 5.281-22.306 5.176Z",
    fill: "#DDDEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.175 131.624v1.92c3.194-2 5.449-4.323 6.762-6.777v-1.918c-1.313 2.452-3.567 4.775-6.762 6.775ZM100.937 124.848v1.918c.92-1.72 1.378-3.503 1.373-5.288v-1.92c.006 1.785-.453 3.569-1.373 5.29Z",
    fill: "#C9C9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.256 107.142c-11.964 6.908-12.024 18.105-.138 25.011 11.886 6.907 31.214 6.907 43.177 0 11.963-6.907 12.029-18.103.144-25.011-11.886-6.906-31.22-6.906-43.183 0Z",
    fill: "#F1F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.182 131.305c-5.296-3.077-8.209-7.204-8.203-11.62.005-4.444 2.963-8.597 8.328-11.694 10.804-6.238 28.33-6.238 39.068 0 5.294 3.078 8.207 7.204 8.2 11.618-.005 4.446-2.964 8.6-8.33 11.698-5.402 3.119-12.482 4.677-19.555 4.677-7.075 0-14.14-1.559-19.508-4.679Zm.72-22.281c-4.978 2.875-7.723 6.662-7.729 10.662-.005 3.971 2.697 7.732 7.608 10.586 10.405 6.046 27.391 6.046 37.867 0 4.98-2.876 7.726-6.663 7.733-10.665.005-3.971-2.696-7.73-7.607-10.584-5.203-3.023-12.05-4.535-18.909-4.535-6.857.001-13.724 1.513-18.962 4.536Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M104.711 59.188c18.495 10.677 18.495 27.99 0 38.668s-48.478 10.678-66.973 0c-18.495-10.679-18.495-27.99 0-38.668 18.495-10.679 48.478-10.679 66.973 0Z",
    fill: "url(#save-mood_svg__m)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M104.711 59.188c-18.495-10.677-48.479-10.677-66.975 0-18.493 10.678-18.493 27.991 0 38.669 18.495 10.677 48.48 10.677 66.974 0 18.496-10.68 18.496-27.992.001-38.669Zm-.351 38.465c-18.301 10.566-47.97 10.566-66.272 0-18.3-10.565-18.3-27.698 0-38.264 18.301-10.566 47.972-10.566 66.272 0 18.3 10.567 18.3 27.699 0 38.264Z",
    fill: "url(#save-mood_svg__n)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M99.722 6.816c15.738 9.086 15.738 23.82 0 32.907-15.739 9.087-41.255 9.087-56.995 0-15.739-9.086-15.739-23.82 0-32.907 15.738-9.088 41.256-9.088 56.995 0Z",
    fill: "url(#save-mood_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M99.723 6.816c-15.74-9.086-41.256-9.086-56.995 0-15.738 9.087-15.738 23.821 0 32.908 15.738 9.086 41.256 9.086 56.995 0 15.738-9.088 15.738-23.821 0-32.908Zm-.299 32.735c-15.573 8.991-40.823 8.991-56.398 0-15.575-8.992-15.575-23.57 0-32.563 15.574-8.991 40.824-8.991 56.398 0 15.573 8.992 15.573 23.57 0 32.563Z",
    fill: "url(#save-mood_svg__p)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.056 8.608v18.316c-3.153 1.265-6.162 2.71-8.975 4.335-6.96 4.018-12.021 8.714-15.179 13.717V26.662c3.158-5.01 8.22-9.706 15.18-13.722a69.495 69.495 0 0 1 8.974-4.332ZM90.918 100.147V81.832c3.152-.771 6.161-1.745 8.974-2.929 6.96-2.927 14.241-8.11 17.4-12.62V84.6c-3.158 4.515-10.439 9.698-17.399 12.625-2.814 1.185-5.823 2.158-8.975 2.923ZM109.573 23.763v11.55c-1.82-3.863-5.359-7.511-10.617-10.545a43.012 43.012 0 0 0-3.908-1.99V11.223a43.045 43.045 0 0 1 3.908 1.992c5.258 3.036 8.797 6.685 10.617 10.548Z",
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.025 47.774s4.964-1.93 6.255-7.464c1.875-8.034-7.508-8.967-11.185-13.974-3.677-5.006-9.952-16.215-20.538-12.32-12.825 4.716-21.596.253-24.079 22.462-2.097 18.752 24.648 29.125 24.648 29.125l24.899-17.829Z",
    fill: "url(#save-mood_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.443 59.477c0 .203-.784 19.92-1.862 24.973-6.398 1.952-14.873-6.688-15.747-8.574-.877-1.886 6.886-23.594 7.155-25.816.27-2.224 10.454 9.417 10.454 9.417Z",
    fill: "url(#save-mood_svg__r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.994 45.038s-1.151 3.618-3.761 10.491C94.879 67 88.704 70.713 86.529 71.773c-2.176 1.059-8.5.808-14.744-9.608-6.242-10.42 2.09-15.395 2.305-16.037.075-.233 1.139-2.408 2.457-5.072 3-6.067 10.553-8.364 16.353-4.873 4.614 2.776 7.902 5.69 10.094 8.855Z",
    fill: "url(#save-mood_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.916 45.884s-11.715 12.125 0 28.963c11.714 16.838 12.51 29.645-1.828 40.98-14.34 11.334-40.948-10.634-34.295-34.849 6.653-24.215 14.925-21.705 11.64-39.182-3.123-16.629 12.908-31.25 26.608-22.955 13.7 8.292-2.125 27.043-2.125 27.043Z",
    fill: "url(#save-mood_svg__t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.655 41.866s1.194 4.337-1.965 3.51c-3.155-.824-7.684-7.137-13.682-4.926-6.001 2.214-10.08-2.786-11.569 4.093-1.488 6.88-3.875 8.142-6.19 10.069-2.316 1.927-1.337 9.118-4.224 2.399-2.886-6.72-5.172-9.3-.252-13.586 4.92-4.284 9.101-5.893 12.335-9.275 3.235-3.382 6.456-3.852 8.558-3.373 2.107.476 12.527 5.819 13.34 6.452.812.635 3.649 4.637 3.649 4.637Z",
    fill: "url(#save-mood_svg__u)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m131.013 17.18-114.205.337 27.379 105.026s4.869 12.797 28.774 12.797 26.529-12.797 26.529-12.797l31.523-105.364Z",
    fill: "url(#save-mood_svg__v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41 85.807a.526.526 0 0 0-.382.558l-.002 5.716c.017.24.671.73.927.635 9.155-3.36 15.996-7.19 21.946-11.353.352-.248.552-.66.521-1.088l.06-5.497c-.014-.2-.597-.642-.871-.403-5.26 4.576-11.991 8.545-22.2 11.432Z",
    fill: "url(#save-mood_svg__w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.89 86.113a.526.526 0 0 0-.38.558l-.003 5.715c.017.24.258.399.486.32 7.218-2.516 13.219-5.31 18.341-8.406l.84 1.674.403-2.442c.969-.611 1.502-1.075 2.41-1.71.349-.245.542-.657.511-1.082l-.002-5.893a.244.244 0 0 0-.405-.166c-5.245 4.595-11.993 8.544-22.2 11.432Z",
    fill: "#00AF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.634 87.92a.184.184 0 0 1-.191-.141.182.182 0 0 1 .136-.22c.103-.022 10.389-3.034 19.254-9.633a.183.183 0 0 1 .256.038.181.181 0 0 1-.038.256c-8.923 6.644-19.287 9.672-19.389 9.697a.105.105 0 0 1-.028.003ZM95.789 90.102a.184.184 0 0 1-.191-.14.182.182 0 0 1 .136-.22c.102-.023 10.389-3.035 19.254-9.634a.183.183 0 0 1 .218.294c-8.923 6.644-19.287 9.672-19.389 9.697a.106.106 0 0 1-.028.003Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.995 153.005s.352.927.46 1.272c.069.212.002.804-.058 1.229a.748.748 0 0 1-.514.607 1.837 1.837 0 0 1-1.472-.16l-4.077-2.35a.486.486 0 0 1-.202-.619l.09-.206a.765.765 0 0 1 .834-.442c.897.16 2.559.416 3.127.224.795-.265 1.812.445 1.812.445Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.141 149.943s-.013 2.791-.119 3.179c-.107.392-1.376.378-1.716-.46-.289-.712-.447-3.031-.447-3.031l2.282.312Z",
    fill: "url(#save-mood_svg__x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 154.216s.432.998.568 1.372c.083.229.041.879-.006 1.348a.819.819 0 0 1-.532.69 2.014 2.014 0 0 1-1.619-.104l-4.579-2.373a.537.537 0 0 1-.251-.67l.09-.228a.838.838 0 0 1 .893-.527c.988.131 2.819.33 3.433.095.855-.33 2.003.397 2.003.397Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.323 151.724s.218 2.781.144 3.18c-.075.399-1.34.489-1.748-.32-.346-.686-.694-2.983-.694-2.983l2.298.123Z",
    fill: "url(#save-mood_svg__y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.401 121.889s-2.18 11.083-1.722 13.974c.87 5.482-.204 14.08-.204 14.08-.982.61-2.008.606-2.817 0 0 0-1.27-18.275-3.542-22.153v-6.152l3.026-3.304 5.354-2.107c.344.903.089 4.592-.095 5.662Z",
    fill: "url(#save-mood_svg__z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.526 120.753s.521 7.468 1.605 14.977c1.021 7.067 2.602 14.132 2.828 16.207.033.311.201.587.461.759.343.231.899.451 1.67.292a.688.688 0 0 0 .536-.606c.236-2.305.359-12.816.352-14.714-.008-2.143 1.831-14.775 1.831-14.775l-.599-5.133-8.684 2.993Z",
    fill: "url(#save-mood_svg__A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.858 85.703.404 3.921c.031.305.267.55.568.6a4.082 4.082 0 0 0 3.05-.678c.422-.289.607-.819.483-1.314l-.724-2.891-3.781.362Z",
    fill: "url(#save-mood_svg__B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.858 79.318s-.758 4.939-.261 6.245c.495 1.306 3.6 1.903 4.395 1.515.797-.389 3.142-3.08 3.268-4.266.722-6.876-3.546-7.012-7.402-3.494Z",
    fill: "url(#save-mood_svg__C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.103 107.237c-2.24-1.687-5.209.132-5.226 2.93-.001.268.246.493.495.409a.35.35 0 0 0 .13-.078c.343-.313.821-1.369 1.608-1.53.928-.19 1.452.128 2.57-.432l.423-1.299Z",
    fill: "url(#save-mood_svg__D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.415 99.66c-1.051-1.423-2.853-2.785-4.014-4.5-1.072-1.584-1.772-3.284-2.52-4.928-.743-.131-2.312-.534-2.573-1.366-.277-.885.653-1.695.415-2.552-.168-.603-1.009-.624-.822-1.436 2.686.864 4.381 3.185 5.992 5.51.477.689.998 1.416 1.571 2.086 1.125 1.318 1.939 2.882 2.283 4.58.224 1.117.242 2.185-.332 2.606Z",
    fill: "url(#save-mood_svg__E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.694 88.89c-.203-.24-.693-.684-.945-.705-.099-.008-.113.052-.141.416-.062.79-1.22 2.28-1.221 3.117-.006 2.822 3.895 7.91 6.739 9.053 2.526 1.013 8.572-2.347 9.727-3.153 1.154-.807 2.326-3.538-.237-4.503-2.563-.964-7.528 2.735-8.273 2.695-1.596-.088-4.224-5.25-5.649-6.92Z",
    fill: "url(#save-mood_svg__F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.741 90.2c-.812 2.777-3.19 3.704-5.746 7.653-1.969 3.042-.748 6.928-.537 11.987.208 5-1.467 7.609-1.033 11.291.059.508.544.973 2.514 1.711 1.97.739 10.96-1.181 12.472-3.5 1.512-2.318-1.49-7.215-1.259-8.883 1.025-7.376.406-19.31-1.441-20.91-.492-.427-.084-1.603-.952-1.366-2.487.68-1.647.233-3.674.122-.628-.033-.231 1.507-.344 1.894Z",
    fill: "url(#save-mood_svg__G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.833 106.443s-1.501-.15-1.881 1.288c-.38 1.438 0 1.911 0 1.911s8.409 1.869 10.806-.043c2.129-1.695 5.504-12.755 5.373-14.159-.132-1.402-1.929-3.769-4.033-2.016-2.104 1.753-2.897 9.156-4.918 11.344-1.085 1.177-5.347 1.675-5.347 1.675Z",
    fill: "url(#save-mood_svg__H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.323 93.253c1.881-.029 3.213 2.04 3.682 3.77.756 2.792.477 5.262-.154 8.053-.278 1.232-.611 2.69-1.143 3.325-1.282 1.53-2.661-.413-2.959-.028-.495.638-.612.599-.249.799.931.513 2.631 1.77 3.973-.115.85-1.192 1.02-1.906 1.45-3.334.84-2.797.964-6.329.403-9.198-.33-1.69-1.924-5.356-4.232-3.937-.245.15-.5.262-.771.665Z",
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39 97.487c1.664.145 3.52-.466 4.922.464 1.714 1.136 1.428 4.095 1.037 6.043-.434 2.156-1.003 6.226-4.152 5.309-1.382-.402-2.578-1.417-2.65-2.882-.115-2.353.351-4.709.663-7.022.143-1.06-.15-2.01 1.021-2.318.587-.155 1.681.043 2.18.345a2.566 2.566 0 0 1 1.45.282c1.167.657 1.155 2.06.407 3.148",
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.267 78.17c-.379 1.71.092 2.962 1.419 3.887 1.352.942 2.432 2.67 2.443 4.182.015 1.846-2.563 3.363-2.308 5.224.114.841.507 1.006 1.14 1.212.696.226 1.293.626 1.712 1.26.787 1.193 1.118 2.076 2.714 2.213 1.623.138 3.456-1.133 3.603-2.824.045-.513-.314-1.015-.191-1.517.139-.561.757-.983 1.145-1.37 1.123-1.118 2.767-3.403 1.789-5.018-.355-.583-.971-.953-1.382-1.496-.447-.592-.647-1.177-.772-1.908-.269-1.565-.196-3.115-1.562-4.16-.492-.377-.91-.6-1.299-1.075a4.504 4.504 0 0 0-1.515-1.215c-.992-.5-2.386-.724-3.477-.663-1.454.082-3.307.758-4.322 1.817-.994 1.038-.976 2.482-.112 2.626.305.05.772-.188.862.132.199.706.592 1.146 1.267 1.719",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.098 135.046c5.313-3.067 13.955-3.067 19.266.001 5.313 3.067 5.314 8.057.002 11.123-5.313 3.068-13.956 3.068-19.269-.001-5.31-3.066-5.311-8.057.001-11.123Z",
    fill: "#009983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.097 145.859c5.313 3.068 13.955 3.069 19.268.001 2.546-1.47 3.87-3.383 3.975-5.313l.01.006.006-2.669-.568.488c-.622-1.218-1.761-2.367-3.424-3.327-5.311-3.066-13.953-3.067-19.266 0-1.592.92-2.705 2.011-3.344 3.174l-.633-.255-.006 2.637.01-.007c.125 1.914 1.447 3.807 3.972 5.265Z",
    fill: "url(#save-mood_svg__I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.105 132.336c5.312-3.066 13.955-3.065 19.266.001 5.313 3.067 5.314 8.058.003 11.123-5.314 3.067-13.956 3.066-19.27 0-5.31-3.065-5.311-8.055.001-11.124Z",
    fill: "#6CC56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.374 143.104c2.58-1.491 3.907-3.434 3.98-5.391-.078-1.952-1.406-3.889-3.981-5.376-5.311-3.066-13.955-3.067-19.266-.001-2.581 1.491-3.908 3.436-3.981 5.393.08 1.949 1.407 3.887 3.981 5.374 5.311 3.068 13.955 3.068 19.267.001Z",
    fill: "url(#save-mood_svg__J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.78 140.088c-2.255 1.302-5.55 1.851-9.038 1.507-.25-.026-.469-.105-.616-.223-.149-.121-.203-.267-.162-.412a.533.533 0 0 1 .266-.295c.219-.127.53-.184.834-.153 2.871.282 5.558-.154 7.37-1.201 1.813-1.047 2.57-2.598 2.078-4.254-.05-.176.048-.356.266-.482.139-.081.317-.135.512-.153.25-.024.502.008.71.094.208.085.346.21.389.354.599 2.013-.352 3.914-2.609 5.218ZM12.674 136.242c1.188.684 1.465 1.635.623 2.123-.842.486-2.488.324-3.676-.361-1.186-.685-1.467-1.636-.624-2.122.843-.488 2.49-.326 3.677.36ZM19.39 132.364c1.188.685 1.466 1.635.625 2.121-.845.487-2.49.326-3.677-.359-1.186-.686-1.467-1.636-.622-2.123.841-.487 2.487-.325 3.675.361Z",
    fill: "#6CC56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.247 135.237c-.043-.144-.18-.27-.389-.356a1.54 1.54 0 0 0-.71-.094 1.256 1.256 0 0 0-.511.154.771.771 0 0 0-.127.09c.002.01.002.018.005.027.242.814.179 1.603-.16 2.321-.293.885-.994 1.681-2.064 2.297-1.812 1.048-4.498 1.484-7.37 1.201-.303-.03-.615.028-.834.154a.652.652 0 0 0-.128.094c.02.087.077.173.17.246.146.12.365.201.614.225 3.488.345 6.783-.203 9.038-1.506 1.188-.686 2.013-1.537 2.442-2.485.253-.747.268-1.547.024-2.368ZM8.85 136.22a1.078 1.078 0 0 0-.334.291c-.052.468.334 1.022 1.102 1.467 1.188.685 2.834.847 3.677.36.145-.084.255-.183.335-.291.051-.468-.334-1.025-1.104-1.468-1.186-.686-2.83-.845-3.675-.359ZM15.568 132.342a1.08 1.08 0 0 0-.335.291c-.052.468.333 1.022 1.103 1.467 1.187.686 2.834.847 3.677.359.145-.084.254-.182.335-.29.051-.469-.334-1.023-1.103-1.468-1.189-.683-2.833-.845-3.678-.359Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.216 55.377c2.064-1.191 5.421-1.191 7.485 0 2.063 1.192 2.063 3.13.001 4.321-2.064 1.192-5.421 1.192-7.485 0-2.065-1.191-2.065-3.13-.001-4.32Z",
    fill: "#BB1900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.215 59.578c2.064 1.191 5.421 1.191 7.486 0 .989-.572 1.503-1.315 1.545-2.064l.003.004.003-1.038-.221.19c-.241-.474-.684-.92-1.33-1.293-2.064-1.191-5.421-1.191-7.483 0-.619.357-1.052.781-1.299 1.233l-.246-.098-.003 1.024.004-.002c.046.743.56 1.477 1.541 2.044Z",
    fill: "url(#save-mood_svg__K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.22 54.325c2.063-1.192 5.421-1.192 7.483 0 2.064 1.191 2.064 3.13.001 4.32-2.063 1.192-5.421 1.192-7.484 0-2.064-1.19-2.064-3.128 0-4.32Z",
    fill: "#FD6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.705 58.507c1.002-.579 1.517-1.334 1.545-2.094-.031-.758-.545-1.51-1.547-2.088-2.063-1.192-5.421-1.192-7.483 0-1.003.578-1.518 1.334-1.547 2.095.032.758.546 1.51 1.546 2.088 2.065 1.19 5.422 1.19 7.486-.001Z",
    fill: "url(#save-mood_svg__L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.014 56.187c.819-.472 2.015-.672 3.281-.547a.43.43 0 0 1 .224.082c.054.044.074.096.059.148a.193.193 0 0 1-.097.108.522.522 0 0 1-.303.056c-1.041-.104-2.017.056-2.675.436-.658.38-.933.943-.754 1.543.019.065-.017.13-.096.175a.547.547 0 0 1-.444.022c-.075-.031-.125-.077-.141-.13-.218-.73.128-1.42.946-1.893ZM119.72 55.683c.461.267.57.636.242.825-.328.188-.967.126-1.428-.14-.461-.266-.57-.636-.242-.825.326-.189.966-.126 1.428.14ZM122.328 54.178c.461.266.569.635.243.824-.328.189-.967.127-1.428-.14-.462-.266-.569-.636-.242-.825.326-.188.966-.126 1.427.14Z",
    fill: "#FD7070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.015 56.188c-.444.255-.747.575-.899.93-.08.26-.08.536.003.819.016.052.066.099.142.129.075.03.166.043.258.033a.46.46 0 0 0 .186-.055.225.225 0 0 0 .044-.032 1.15 1.15 0 0 1 .043-.805c.097-.342.357-.647.765-.883.658-.379 1.632-.538 2.675-.435a.521.521 0 0 0 .303-.056.242.242 0 0 0 .043-.032.18.18 0 0 0-.057-.081.43.43 0 0 0-.225-.082c-1.268-.123-2.463.077-3.281.55ZM118.291 55.544a.4.4 0 0 0-.135.12c-.015.18.135.392.43.56.462.268 1.101.33 1.428.14a.418.418 0 0 0 .135-.118c.014-.18-.135-.393-.429-.563-.462-.266-1.101-.33-1.429-.14ZM120.899 54.037a.444.444 0 0 0-.135.12c-.014.18.135.392.43.563.461.266 1.101.328 1.428.14a.389.389 0 0 0 .135-.12c.015-.179-.135-.392-.43-.561-.46-.268-1.1-.33-1.428-.142Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.857 12.497a.41.41 0 0 1 .205.268c.02.064.032.137.032.22 0 .221-.08.463-.237.726-.147.252-.325.43-.536.536-.189.115-.357.131-.504.047-.136-.084-.205-.236-.205-.457 0-.082.009-.167.023-.252.03-.16.092-.322.182-.488.147-.252.315-.436.504-.551.211-.117.389-.133.536-.049ZM10.558 11.324a.85.85 0 0 1 .023.212c0 .22-.073.457-.22.71-.137.252-.31.44-.52.566-.21.116-.39.131-.537.047-.146-.084-.22-.24-.22-.472 0-.075.007-.151.023-.23.032-.159.098-.325.197-.495.148-.262.326-.446.536-.55.21-.126.384-.147.52-.063a.419.419 0 0 1 .198.275ZM4.834 13.977c.21-.115.393-.131.55-.047.09.056.152.145.182.268a.943.943 0 0 1 .023.22c0 .232-.068.473-.204.725a1.535 1.535 0 0 1-.551.551c-.2.125-.373.146-.52.062-.148-.095-.22-.252-.22-.473 0-.082.008-.166.022-.252a1.7 1.7 0 0 1 .198-.488c.147-.25.321-.439.52-.566Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.252 17.27C.084 17.017 0 16.687 0 16.275v-.015c0-.662.216-1.355.646-2.079.388-.682.877-1.191 1.464-1.527L9.133 8.6l3.496-2.023c.45-.273.844-.357 1.18-.252a.745.745 0 0 1 .284.095c.095.041.173.1.237.173l.725.393a1.08 1.08 0 0 0-.489-.016 1.964 1.964 0 0 0-.755.284L3.29 13.316c-.588.347-1.075.861-1.464 1.544-.385.648-.597 1.269-.637 1.866a3.137 3.137 0 0 0-.008.212v.016c0 .325.052.598.157.818.084.19.21.346.377.473L.71 17.663a.175.175 0 0 1-.063-.032 1.115 1.115 0 0 1-.394-.362ZM3.826 17.835l.362-.204 1.669 1.796-1.18-.662-.85-.93Z",
    fill: "#EA0080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.857 19.427-1.67-1.796-.36.205-.537.315c-.514.294-.955.367-1.323.22-.052-.02-.1-.042-.141-.063a.408.408 0 0 0-.111-.063 1.188 1.188 0 0 1-.378-.473c-.104-.22-.157-.493-.157-.818v-.016c0-.07.003-.14.009-.212.04-.596.253-1.218.637-1.866.388-.682.877-1.196 1.464-1.544l10.52-6.061c.261-.158.513-.253.755-.284.168-.032.33-.027.488.016.063.031.141.068.236.11l.158.126c.293.252.44.661.44 1.228v.016c0 .661-.2 1.354-.598 2.078-.409.682-.902 1.191-1.48 1.527l-6.377 3.701-1.575 3.654Z",
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.558 11.324a.419.419 0 0 0-.197-.275c-.137-.084-.31-.063-.52.062-.21.105-.39.289-.537.55-.1.171-.165.337-.197.497a1.14 1.14 0 0 0-.023.229c0 .231.073.388.22.472.148.084.326.069.536-.047.21-.127.384-.316.52-.567.148-.252.221-.488.221-.709 0-.079-.007-.15-.023-.212ZM7.857 12.497c-.147-.084-.325-.068-.536.048-.189.116-.357.298-.504.55-.09.166-.15.33-.182.489-.015.085-.023.17-.023.252 0 .22.069.373.205.457.147.084.315.068.504-.047.21-.105.389-.284.536-.537.157-.261.237-.504.237-.724a.707.707 0 0 0-.032-.22.411.411 0 0 0-.205-.268ZM4.834 13.978c-.2.125-.373.315-.52.566a1.701 1.701 0 0 0-.198.489 1.358 1.358 0 0 0-.023.252c0 .22.073.377.22.473.148.084.321.063.52-.063.21-.115.394-.3.552-.55.136-.252.204-.494.204-.725a.942.942 0 0 0-.023-.22.413.413 0 0 0-.181-.269c-.158-.084-.34-.069-.551.047Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.746 154.735c-3.612 2.154-9.316 2.075-12.739-.176-3.424-2.253-3.272-5.825.34-7.978 3.612-2.154 9.316-2.076 12.74.176 3.423 2.251 3.271 5.824-.341 7.978Z",
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.462 152.385c-.077 1.456.738 2.925 2.464 4.06 3.425 2.253 9.128 2.332 12.74.177 1.884-1.124 2.817-2.633 2.802-4.14h.009l.068-1.616c-.093 1.416-1.027 2.814-2.798 3.87-3.612 2.154-9.316 2.075-12.739-.176-1.71-1.126-2.528-2.579-2.468-4.022l-.078 1.847Zm.077-1.856c0-.011.002-.021.003-.031h-.002l-.001.031Zm18.017.065h-.007c0 .036.005.071.003.106l.004-.106Z",
    fill: "#EA0080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.709 147.863c-1.326.791-2.044 1.828-2.163 2.885.027 1.06.657 2.116 1.914 2.943 2.663 1.751 7.1 1.813 9.91.138 1.325-.791 2.043-1.827 2.16-2.886-.027-1.06-.656-2.116-1.914-2.942-2.663-1.751-7.098-1.813-9.907-.138Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.547 150.749c.118-1.057.835-2.094 2.162-2.885 2.81-1.675 7.245-1.614 9.908.138 1.257.827 1.887 1.882 1.914 2.942.131-1.184-.491-2.395-1.897-3.32-2.663-1.751-7.1-1.813-9.909-.137-1.483.884-2.209 2.076-2.178 3.262Z",
    fill: "#EA0080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.596 152.852-2.95-1.857-.066-3.584c-.004-.228-.168-.33-.366-.23a.71.71 0 0 0-.35.593l.072 3.756c0 .053.01.102.03.144a.23.23 0 0 0 .08.095l3.057 1.923c.142.089.369-.025.505-.257.136-.234.13-.495-.012-.583Z",
    fill: "url(#save-mood_svg__M)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__b",
    x1: 35.647,
    y1: 32.354,
    x2: 24.467,
    y2: 32.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__c",
    x1: 15.451,
    y1: 91.531,
    x2: 13.202,
    y2: 91.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__d",
    x1: 22.947,
    y1: 85.714,
    x2: 20.383,
    y2: 85.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__e",
    x1: 27.041,
    y1: 41.799,
    x2: 23.031,
    y2: 41.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__f",
    x1: 21.698,
    y1: 23.582,
    x2: 16.959,
    y2: 23.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__g",
    x1: 20.582,
    y1: 43.518,
    x2: 9.663,
    y2: 43.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__h",
    x1: 26.01,
    y1: 44.011,
    x2: 12.633,
    y2: 44.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__i",
    x1: 14.367,
    y1: 39.268,
    x2: 14.367,
    y2: 29.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__j",
    x1: 41.179,
    y1: 28.291,
    x2: 31.984,
    y2: 28.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__k",
    x1: 23.596,
    y1: 20.535,
    x2: 16.75,
    y2: 20.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__l",
    x1: 24.392,
    y1: 17.475,
    x2: 13.348,
    y2: 17.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__m",
    x1: 71.224,
    y1: 104.785,
    x2: 71.224,
    y2: 42.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__n",
    x1: 71.224,
    y1: 104.163,
    x2: 71.224,
    y2: 45.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__o",
    x1: 71.224,
    y1: 45.62,
    x2: 71.224,
    y2: -7.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__p",
    x1: 71.225,
    y1: 45.09,
    x2: 71.225,
    y2: -5.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#E51077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E51077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__q",
    x1: 106.741,
    y1: 6.116,
    x2: 21.931,
    y2: 109.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__r",
    x1: 52.605,
    y1: 106.31,
    x2: 81.021,
    y2: 61.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__s",
    x1: 96.96,
    y1: 94.202,
    x2: 79.129,
    y2: 21.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__t",
    x1: 46.582,
    y1: 67.67,
    x2: 90.252,
    y2: 67.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#810095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#9B0091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#C4008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#FD0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__u",
    x1: 64.898,
    y1: 45.22,
    x2: 105.876,
    y2: 45.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__v",
    x1: 73.91,
    y1: 136.171,
    x2: 73.91,
    y2: -0.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#FF0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF0082",
    stopOpacity: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF0082",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__w",
    x1: 105.352,
    y1: 91.918,
    x2: 104.164,
    y2: 75.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__x",
    x1: 131.141,
    y1: 151.5,
    x2: 128.86,
    y2: 151.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__y",
    x1: 125.451,
    y1: 153.278,
    x2: 123.179,
    y2: 153.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__z",
    x1: 125.116,
    y1: 133.312,
    x2: 133.666,
    y2: 133.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__A",
    x1: 118.526,
    y1: 135.401,
    x2: 127.809,
    y2: 135.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__B",
    x1: 132.153,
    y1: 80.32,
    x2: 119.531,
    y2: 102.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__C",
    x1: 131.143,
    y1: 95.377,
    x2: 123.675,
    y2: 69.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__D",
    x1: 115.103,
    y1: 108.591,
    x2: 108.991,
    y2: 108.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__E",
    x1: 117.987,
    y1: 96.101,
    x2: 105.83,
    y2: 83.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__F",
    x1: 112.388,
    y1: 94.572,
    x2: 130.15,
    y2: 94.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__G",
    x1: 118.354,
    y1: 105.579,
    x2: 133.839,
    y2: 105.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__H",
    x1: 113.783,
    y1: 101.632,
    x2: 130.134,
    y2: 101.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__I",
    x1: 22.208,
    y1: 132.068,
    x2: 12.704,
    y2: 148.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#169D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__J",
    x1: 22.497,
    y1: 129.523,
    x2: 13.014,
    y2: 145.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__K",
    x1: 123.711,
    y1: 54.223,
    x2: 120.018,
    y2: 60.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#E51077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95B11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__L",
    x1: 123.824,
    y1: 53.234,
    x2: 120.14,
    y2: 59.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-mood_svg__M",
    x1: 96.08,
    y1: 153.899,
    x2: 92.316,
    y2: 147.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "save-mood_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h160.271v158.188H0z"
  })))));
};
export { SvgSaveMood as ReactComponent };
export default __webpack_public_path__ + "36f5d1593834b1182eeb94b943ae046b.svg";